





import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 4.2.0
 * @changelog 4.2.0 Published.
 */
@Component
export default class JdsBreakdownHeading extends Vue {
}
